import { useQuery } from '@vue/apollo-composable';
import { GET_STUDENT_RESULT, GET_STUDENT_ATTENDANCE, QUERY_STUDENT_SESSIONS } from '@/graphql';

export function useStudentResultQuery(
  studentId: Ref<number | string | undefined>,
  termId: Ref<number | string | undefined>,
  enabled: Ref<boolean>,
) {

  // Fetch Result Query
  const { result: resultData, loading: loadingResult, error: errorResult, refetch: refetchResult } = useQuery(GET_STUDENT_RESULT,
    () => ({
      student_id: studentId.value,
      academic_calendar_id: termId.value,
    }),
    {
      enabled: enabled,
      fetchPolicy: 'network-only',
    },
  );

  const studentResult = computed(() => resultData.value?.studentResult);

  // Attendance Data
  const { result: attendanceResult, loading: loadingAttendance } = useQuery(GET_STUDENT_ATTENDANCE, () => ({
    student_id: studentId.value,
    academic_calendar_id: termId.value,
  }), {
    enabled: enabled,
  });

  // Student Sessions for Remarks
  const { result: sessionsResult, load: loadSessionData } = QUERY_STUDENT_SESSIONS({ studentId: 0 });

  watch(studentId, (newId) => {
    if (newId) {
      loadSessionData(undefined, { studentId: Number(newId) });
    }
  }, { immediate: true });

  const currentSessionData = computed(() => {
    const calendars = sessionsResult.value?.student?.academicCalendars;
    if (!calendars || !termId.value) return null;
    return calendars.find((c) => c.id === termId.value);
  });

  return {
    studentResult,
    attendanceResult,
    currentSessionData,
    loadingResult,
    loadingAttendance,
    errorResult,
    refetchResult,
  };
}
